export default __webpack_public_path__ + "static/media/shareme.5648afb7.png";